import styled from 'styled-components'
import ContentLoader from 'react-content-loader'

export const Content = styled(ContentLoader)``
